export default "__VITE_ASSET__BHGt6Pq5__"